import { environment } from 'environments/environment';
import { Component, inject } from '@angular/core';
import { ReportsComponent } from 'app/shared/components/reports/reports.component';
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder } from '@angular/forms';
import { NewReportOptionsTemplateDirective } from 'app/shared/directives/new-report-options-template.directive';
import { ReportMonthRangeOptionComponent } from 'app/shared/components/report-month-range-option/report-month-range-option.component';

@Component({
  selector: 'app-capture-admin-wag-billing-api-reports',
  templateUrl: './capture-admin-wag-billing-api-reports.component.html',
  imports: [
    FormsModule,
    NewReportOptionsTemplateDirective,
    ReactiveFormsModule,
    ReportMonthRangeOptionComponent,
    ReportsComponent,
  ],
})
export class CaptureAdminWagBillingApiReportsComponent {
  private formBuilder = inject(UntypedFormBuilder);

  maxYear = new Date().getFullYear();

  reportsUrl = `${environment.captureApi.url}/wag_billing_api_reports`;

  filtersForm = this.formBuilder.group({
    billingDate: [null]
  });
}
